import { useEffect, useState, useRef, lazy, Suspense } from "react";
import { InputGroup } from "react-bootstrap";
import Select from "react-select";
import { AutoComplete, SvgComponent } from "components";
import SuspenseECF from "components/Suspense/SuspenseECF";
import { Simplebar } from "components/Simplebar/Simplebar";
import { VendedorManager } from "managers";
import ToolTip from "components/ToolTip/ToolTip";
import { GridView } from "components/GridView/GridView";
import IconButton from "components/IconButton/IconButton";
import useExceptionHandler from "hooks/useExceptionHandler";
import usePaginationValuesWhere from "hooks/usePaginationValuesWhere";
import { AnimatedIconButton } from "components/AnimatedIconButton/AnimatedIconButton";
import { Vendedor } from "models/ECF/vendedor";
import {
  buttonStyle,
  controlsProportion,
  initialWhere,
  initialWhereModal,
} from "..";
import "../Lookup.style.scss";
import { DEFAULT_PAGINATION_VALUES, ArrayHelper } from "utils";

export const VendedorLookup = ({
  initialValue = { label: "", value: "" },
  onChange,
  isDisabled,
  required = false,
  isMultiselect = false,
  initialValueList,
  onMultiselectChange = () => { },
}) => {
  const ref = useRef(null);
  const [showCanvas, setShowCanvas] = useState(false);
  const [vendedorListModal, setVendedorListModal] = useState([]);
  const [selectedValue, setSelectedValue] = useState({ label: "", value: "" });
  const [multiSelectedValue, setMultiSelectedValue] = useState([]);
  const [whereModal, setWhereModal] = useState(initialWhereModal);
  const [pagination, setPagination] = useState({
    ...DEFAULT_PAGINATION_VALUES,
    CantidadPorPagina: 5,
  });
  const { handleException } = useExceptionHandler();
  const { setPaginationValuesWhere } = usePaginationValuesWhere();
  const ESTATUS_LIST = [
    { value: "", label: "Todos" },
    ...Vendedor.ESTATUS_LIST,
  ];

  useEffect(() => {
    if (whereModal != initialWhereModal) {
      buscar(false);
    }
  }, [whereModal]);

  useEffect(() => {
    if (
      initialValue?.value &&
      initialValue?.value != "" &&
      initialValue.value !== selectedValue.value
    ) {
      setValue();
    }
  }, [initialValue.value]);

  useEffect(() => {
    if (initialValueList && initialValueList?.length > 0) {
      setMultiSelectedValue(initialValueList);
    }
  }, [initialValueList?.length]);

  const setValue = () => {
    VendedorManager.buscarPorId(initialValue.value, true).then((data) =>
      setSelectedValue(data)
    );
  };

  function buscar() {
    const whereWithPaginationValues = { ...whereModal, ...pagination };
    VendedorManager.listado(whereWithPaginationValues)
      .then((res) => {
        setPaginationValuesWhere(res.Headers, pagination, setPagination);
        setVendedorListModal(res.Data);
      })
      .catch((err) => handleException(err));
  }

  const handleCerrar = () => {
    setShowCanvas(false);
    setWhereModal(initialWhereModal);
  };

  const onPageIndexChanging = (pageNumber) => {
    setPagination((prevstate) => {
      return { ...prevstate, IndiceDePagina: pageNumber - 1 };
    });
    setWhereModal({ ...whereModal });
  };

  const getSuggestions = async (value) => {
    const inputValue = value.trim().toLowerCase();
    const res = await VendedorManager.listado({
      ...initialWhere,
      Nombre: inputValue,
    });
    return res.Data;
  };

  const handleMultiselectChange = (value) => {
    setMultiSelectedValue(value ? value : []);
    onMultiselectChange(value ? value : []);
  };

  const handleSelectChange = (value) => {
    setSelectedValue(value ? value : {});
    onChange(value ? value : {});
  };

  return (
    <>
      <InputGroup className="mb-2 w-100">
        <div style={{ width: controlsProportion.input }}>
          <AutoComplete
            required={required}
            placeholder="Vendedores"
            getList={getSuggestions}
            isMultiselect={isMultiselect}
            parentValue={isMultiselect ? multiSelectedValue : selectedValue}
            setParentValue={
              isMultiselect ? handleMultiselectChange : handleSelectChange
            }
            isDisabled={isDisabled}
          />
        </div>
        <InputGroup.Append style={{ width: controlsProportion.button }}>
          <AnimatedIconButton
            size="40px"
            height="18"
            width="18"
            message="Seleccionar Vendedores"
            style={buttonStyle}
            disabled={isDisabled}
            iconName="search"
            onClick={() => {
              setShowCanvas(true);
              setTimeout(() => {
                buscar();
              }, 200);
            }}
          />
        </InputGroup.Append>
      </InputGroup>
      {showCanvas && (
        <Suspense fallback={<SuspenseECF />}>
          <Simplebar
            backdrop={true}
            ref={ref}
            placement={"end"}
            portal={false}
            size="xl"
            useLoading={true}
            visible={showCanvas}
            setShow={(e) => {
              setShowCanvas(e);
            }}
            title="Seleccionar Vendedor"
            btnLeft={{
              show: false,
              func: () => { },
            }}
            btnRight={{
              show: false,
              func: () => { },
            }}
          >
            <GridView
              pagination={pagination}
              setPagination={setPagination}
              allowPaging={pagination.EsPaginable}
              pageSize={pagination.CantidadPorPagina}
              pageIndex={pagination.IndiceDePagina}
              lastPageNumber={pagination.PaginasTotal}
              dataSource={vendedorListModal}
              onPageIndexChanging={onPageIndexChanging}
              where={whereModal}
              setWhere={setWhereModal}
            >
              <GridView.Column
                isSticky
                bodyRenderer={(row) => {
                  return (
                    <div className="float-right">
                      <IconButton
                        onClick={() => {
                          let values = multiSelectedValue;
                          if (values === null || values === undefined) {
                            values = [];
                          }
                          isMultiselect
                            ? handleMultiselectChange(
                              ArrayHelper.removeObjectsDuplicated(
                                [
                                  ...values,
                                  {
                                    label: row.Nombre,
                                    value: row.IdSec,
                                  },
                                ],
                                ["value", "label"]
                              )
                            )
                            : handleSelectChange({
                              label: row.Nombre,
                              value: row.IdSec,
                            });
                          handleCerrar();
                        }}
                      >
                        <ToolTip message="Seleccionar">
                          <div>
                            <SvgComponent
                              height="20"
                              width="20"
                              iconName="check"
                            />
                          </div>
                        </ToolTip>
                      </IconButton>
                    </div>
                  );
                }}
              />
              <GridView.Column
                headerText="Nombre"
                dataField="Nombre"
                sortExpression="Nombre"
              />
              <GridView.Column
                headerText="Tipo"
                dataField="TipoNombre"
                sortExpression="TipoNombre"
              />
              <GridView.Column
                headerText="Teléfono"
                dataField="TelefonoPrincipal"
                sortExpression="TelefonoPrincipal"
              />
              <GridView.Column
                headerText="Estatus"
                dataField="Estatus"
                sortExpression="Estatus"
                filterRenderer={() => {
                  return (
                    <Select
                      className="react-select primary"
                      options={ESTATUS_LIST}
                      value={ESTATUS_LIST.filter(function (option) {
                        return (
                          option.value ===
                          (whereModal.Estatus
                            ? whereModal.Estatus
                            : ESTATUS_LIST[0].value)
                        );
                      })}
                      name="Estatus"
                      onChange={(e) =>
                        setWhereModal({
                          ...whereModal,
                          Estatus: e.value,
                        })
                      }
                    ></Select>
                  );
                }}
              />
            </GridView>
          </Simplebar>
        </Suspense>
      )}
    </>
  );
};
